import actions from './actions';
import mutations from './mutations';

const state = {
    error: {},
    events: {
        mcd: [],
        summit: [],
        masterclass: [],
        'live-course': []
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}